<template>

    <section id="new_ref_fifth_step" class="flex" v-if="associatedRef">


        <titlePage>
            <template slot="titleBody">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 ">{{ currentEval.candidate_first_name }} {{ currentEval.candidate_last_name }}</h1>
                    <h2 class="associated_ref_name">{{ $t('modules.evaluations.formStep3.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
                </div>
            </template>
        </titlePage>

        <div class="hero flex subsection_container">

            <div class="hero-body flex_content">
                <div class="container  micro-container has-text-centered">

                    <div class="email_inputs_container" v-if="canAccessCustomisation">

                        <h2 class="title is-size-1 has-text-weight-bold stepTitle has-text-centered">
                            {{ $t('modules.evaluations.formStep3.title') }}
                        </h2>

                        <div class="custom_email_mini_container">
                            <notifText class="notice_custom_email">
                                {{ $t('modules.evaluations.formStep3.notice') }}
                            </notifText>
                            <br>
                            <br>
                            <SwitchInput switchId="email_custom_enabled"
                                class="custom_email_switch"
                                :switchLabel="$t('modules.evaluations.formStep3.radioLabel')"
                                :falseValue="false"
                                :trueValue="true"
                                :value="currentEval.use_custom_email"
                                @change="handleSwitch" />

                            <transition name="fade">
                                <div class="custom_email_inputs" v-if="currentEval.use_custom_email">
                                    <InputMaterialWrap
                                        v-model="emailSubject"
                                        :label="$t('modules.evaluations.formStep3.subjectLabel')"
                                        input-id="contactEmailSubject" />

                                    <TextareaMaterialWrap
                                        v-model="emailContent"
                                        :label="$t('modules.evaluations.formStep3.contentLabel')"
                                        input-id="contactEmailContent" />

                                </div>
                            </transition>
                        </div>

                    </div>
                    <div class="email_not_autorized" v-else >
                        <h2 class="title is-size-1 has-text-weight-light stepTitle has-text-centered">{{ $t('modules.positions.formStep4.title') }}</h2>
                        <notifText class="has-text-centered" v-html="$t('modules.evaluations.formStep3.noAccessNotice')" />
                    </div>

                        <btn-circle-icon
                            class="large is-cursor"
                            icon="icon-arrow-right"
                            @click.native="nextStep" />
                </div>
            </div>
        </div>

    </section>

</template>

<script>
import titlePage from "@/components/layouts/titlePage"
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'formEvalStep3',
    components: {
        titlePage
    },
    data(){
        return {
            canAccessCustomisation: userCanAccess('extra', 'customisation')
        }
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        },
        associatedRef(){
            return this.$store.state.EvalStore.associatedRef
        },
        emailSubject: {
            get(){
                return this.currentEval.email_subject
            },
            set(value){
                this.$store.commit('EvalStore/updateEvalData', {email_subject: value} )
            }
        },
        emailContent: {
            get(){
                return this.currentEval.email_content
            },
            set(value){
                this.$store.commit('EvalStore/updateEvalData', {email_content: value} )
            }
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        handleSwitch(id, value){
            this.$store.commit('EvalStore/updateEvalData', {use_custom_email: value} )
        },
        nextStep(){
            this.$store.commit('EvalStore/changeCurrentStep', { index: 3 })
        },
    }
}
</script>

<style lang="scss" >
#new_ref_fifth_step{
    background: $white;

    display: flex;
    flex-direction: column;
    .subsection_container{
        background: $white;
        .hero-body{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 100px;
            .stepTitle{
                max-width: 500px;
                text-align: center;
            }
        }
    }
    .bottom_btn_container{
        display: flex;
        justify-content: space-around;
    }
    .evals_actions{
        .btn_underline{
            width: 240px;
        }
    }
    .email_notice{
        margin-top: 20px;
        max-width: 500px;
        margin: 20px auto 0;
        color: $grey;
    }
}
</style>